import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PROFILE_NOTIFICATION_LOADERS, PROFILE_NOTIFICATION_MODULE_NAMESPACE } from '../../../../store/profile-notification/profile-notification-types.store';


const ProfileNotificationStore= namespace(PROFILE_NOTIFICATION_MODULE_NAMESPACE)

@Component({
  components: {
     'notification-type-loader' : async () => import('../../loaders/profile-notification-type-loader/ProfileNotificationTypeLoader.vue')
  }
})
class ProfileNotificationDataTable extends Vue {

  @Prop({ type: [Array] })
  items: any[];

  selected: any;
  headers: any;
  dataTableProps: any;
  search: any;

  @ProfileNotificationStore.Getter loaders: Map<string,boolean>

  constructor() {
    super();
    this.selected = [];
    this.headers = [];
    this.search = '';
  }

  created() {
    this.headers = [
      {
        text: this.$t(this.lblSetting.lblName),
        align: 'left',
        sortable: true,
        value: 'name'
      },
      //{ text: 'Type', value: 'sub_type'},
      { text: 'App', value: 'app', sortable: false },
      { text: 'Email', value: 'email', sortable: false },
      { text: 'SMS', value: 'sms', sortable: false }
    ];
  }

  get lblSetting() {
    return {
      ...require('../../../../locales/profile/index').default,
      ...require('../../../../locales/generic-labels').default
    };
  }

  get coLoader(): boolean {
    return this.loaders.get(PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_DETAILS)
  }

  @Emit('on-click-checkbox')
  onClickCheckbox() { }


}

export default ProfileNotificationDataTable;



// WEBPACK FOOTER //
// ./src/containers/profile/components/profile-notification-data-table/index.ts